import { datadogRum } from "@datadog/browser-rum";
import { APP_ENV } from "#next/appEnv";
import { RankingTabs } from "#next/utils/interfaces";
import { TTimeRanges } from "#next/utils/shared";

type ExplorerRankings = `Rankings > ${Capitalize<RankingTabs>}`; // Done

type ExplorerRankingsFilter = `${ExplorerRankings} > Filter`; // Done

type Feed = `Feed > ${
  | "Export > CSV"
  | "Post Expanded"
  | "Post Collapsed"
  | "Open Source"
  | "Copy URL to Clipboard"
  | "User Modal > Open"
  | "Conversation Modal > Open"
  | "Image"
  | "Score"
  | "Translation Toggled On"
  | "Translation Toggled Off"}`;

type SinglePost =
  `Single Post > ${`User Search > ${"Open" | "Close"}` | `Image > ${"Open" | "Close"}` | Feed}`;

type UserSearch =
  `User Search > ${"Open" | "Close" | "Generate Report" | "View Report" | Feed}`;

type Preview = `Preview > ${"Run" | Feed}`;

type PostModal = `Post Modal > ${"Open" | "Close" | Feed}`;

type Explorer = `Explorer > ${
  | "Open"
  | "Reset Feed"
  | "Generate Report"
  | "View Report"
  | `Time Range > ${TTimeRanges}`
  | `Platform > ${"Open" | "Change Selection"}`
  | `Language > ${"Open" | "Change Selection"}`
  | `Relevance > ${"Open" | "Change Selection"}`
  | `Narrative > ${"Open" | "Change Selection"}`
  | `Keyword Filter > ${"Filter" | "Clear"}`
  | `Media > ${"Open" | "Change Selection"}`
  | `Map > Filter`
  | `Graph > Type > Change`
  | `Graph > Mode > Change`
  | `Graph > Filter`
  | ExplorerRankings
  | ExplorerRankingsFilter
  | Feed
  | UserSearch
  | PostModal}`;

type Subscribe = `Subscribe > ${
  | "Add Email"
  | "Remove Email"
  | "Subscribe"
  | "Update"
  | "Cancel"
  | "Change Frequency"
  | "Change Project"
  | "Change Include"}`;

export type ProjectEditor = `Project Editor > ${
  | "Open (Edit)"
  | "Open (View)"
  | "Open (Create)"
  | "Save"
  | "Delete"
  | "Preview"
  | `Sharing Settings > ${"Open" | "Save" | "Cancel"}`
  | `Manage Narratives > ${"Open" | "Add Narrative" | "Cancel" | "Save"}`
  | Subscribe}`;

export type LeftSideNav =
  | "Help > Open"
  | "Pyrra Admin > Open"
  | "Catalog > Open"
  | "Quick User Search > Open"
  | "Feedback > Open"
  | `My Subscriptions > ${"Open"}` // TODO: Flesh out
  | `My Settings > ${
      | "Open"
      | "Change Timezone"
      | "Add Email"
      | "Delete Email"
      | "Save"}`;

type MySubscriptions = `My Subscriptions > ${
  | "Create"
  | "Edit"
  | "Delete Dialog > Open"
  | "Delete Dialog > Delete"}`;

export const trackAction = (
  action:
    | Explorer
    | UserSearch
    | ProjectEditor
    | LeftSideNav
    | MySubscriptions
    | Subscribe
    | SinglePost
    | Preview
    | PostModal,
) => {
  try {
    if (APP_ENV === "production") {
      datadogRum.addAction(action);
      return;
    }
    if (APP_ENV === "pre-release") {
      datadogRum.addAction(action);
    }
    console.log(`Tracked action: "${action}"`);
  } catch (err) {
    console.error("Error trying to track user action", err);
  }
};
